import { render } from "./ProfileEdit.vue?vue&type=template&id=1b172666&scoped=true"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"

import "./ProfileEdit.vue?vue&type=style&index=0&id=1b172666&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b172666"]])

export default __exports__